import de from './de';
import en from './en';

export default {
    de,
    en,
    'en-US': en,
    'en-GB': en,
    'en-CA': en,
    'en-NZ': en,
    'en-AU': en,
    'de-DE': de,
    'de-AT': de,
    'de-CH': de
};
